import React from 'react';
import {Container} from "@mui/material";
import {DecoImage} from "../features/decoration/decoration";
import {DecoImages} from "../features/decoration/decoImages";
import {useWindowResizeToMobile} from "../features/util/responsive/mobile";
import styled from "@emotion/styled";
import {Constants} from "../features/constants/appConstants";

const PrivacyPolicy = () => {
  const isMobile = useWindowResizeToMobile();

  return (
    <div className={`bg-[#F7F8F5] mt-14 overflow-hidden`}>
      <div className={`flex justify-center relative overflow-hidden py-10 md:py-16`}>
        {!isMobile &&
            <>
              <DecoImage style={DecoImages.paperAirplane}/>
              <DecoImage style={DecoImages.flyPaperAirPlane}/>
              <DecoImage style={DecoImages.boxPattern1}/>
              <DecoImage style={DecoImages.boxPattern2}/>
              <DecoImage style={DecoImages.boxPattern3}/>
              <DecoImage style={DecoImages.boxPattern4}/>
              <DecoImage style={DecoImages.boxPatternPink}/>
              <DecoImage style={DecoImages.boxPatternBlue}/>
            </>}
        <Container maxWidth={'md'} sx={{zIndex: '20'}}>
          <h2
            className={"text-xl md:text-2xl text-[#243242] text-center font-medium mb-6 md:mb-10"}>個人情報保護方針</h2>
          <div
            className={`border border-black border-b-0 h-[2.5rem] bg-[#45AF7D] flex items-center pl-4 rounded-tl-[1rem] rounded-tr-[1rem] rounded-br-none rounded-bl-none`}>
            <div className={`w-4 h-4 rounded-full m-2 bg-[#FF577F]`}/>
            <div className={`w-4 h-4 rounded-full m-2 bg-[#F8D637]`}/>
            <div className={`w-4 h-4 rounded-full m-2 bg-[#2EDB48]`}/>
          </div>
          <div
            className={`border-[1.5px] border-black rounded-bl-[1rem] rounded-br-[1rem] rounded-tr-none rounded-tl-none bg-[#DDF1E9]`}>
            <div className={`${!isMobile ? 'm-8' : 'm-5'} p-4 bg-white border-[1px] border-black rounded-[0.85rem]`}>
              <div
                className={"space-y-6 space-x-0 md:space-y-8 md:pl-4 pb-9 overflow-y-scroll max-h-[30rem] md:max-h-[45rem] text-xs md:text-base"}>
                <div className="text-end text-base font-medium pr-1 mt-1">
                  制定日2023年10月13日
                  <br/>
                  代表取締役 李 秀秉
                </div>
                <div className={`text-base privacy-policy`}>
                  <p>
                    {`　`}NAMU TECH
                    JAPAN株式会社は、コンピュータ機器等の販売・輸出入、コンピュータシステムの運用・保守に関する業務、その他のＩＴ及び自動化設備技術サービス関連業務を通じてＩＴ社会に貢献することを企業理念とし、当社が取り扱う全ての個人情報の保護について、社会的使命を十分に認識し、本人の権利を保護し、個人情報に関する法令等を遵守致します。
                  </p>
                  <p>
                    {`　`}また、以下に示す方針を具現化するための個人情報保護マネジメントシステムを構築し、最新のＩＴ技術の動向、社会的要請の変化、経営環境の変動等を常に認識しながら、その継続的改善に、全社を挙げて取り組むことをここに宣言致します。
                  </p>
                  <br/>
                  <ol className="list-decimal pl-7">
                    <li>
                      <p>
                        当社はコンピュータ機器等の販売・輸出入、コンピュータシステムの運用・保守に関する業務、その他のＩＴ及び自動化設備技術サービス関連業務、並びに従業者の雇用、人事管理等において取扱う個人情報について、適切な取得・利用及び提供を行い、特定された利用目的の達成に必要な範囲を超えた個人情報の取扱いを行いません。また、そのための措置を講じます。
                      </p>
                    </li>
                    <li>
                      <p>
                        当社は個人情報の取扱いに関する法令、国が定める指針その他の規範を遵守致します
                      </p>
                    </li>
                    <li>
                      <p>
                        当社は個人情報の漏えい、滅失、き損などのリスクに対しては、合理的な安全対策を講じて防止すべく、事業の実情に合致した経営資源を投入し、個人情報のセキュリティ対策を継続的に向上させていきます。また、万一の際には速やかに安全対策の是正措置を講じます。
                      </p>
                    </li>
                    <li>
                      <p>
                        当社は個人情報取扱いに関する苦情及び相談に対しては、迅速かつ誠実に対応致します。
                      </p>
                    </li>
                    <li>
                      <p>
                        個人情報保護マネジメントシステムは、当社を取り巻く環境の変化と実情を踏まえて適時・適切に見直し、継続的に改善をはかります。
                      </p>
                    </li>
                  </ol>
                  <br/>
                  <p>
                    当社の個人情報保護方針についてのお問合せは、以下の相談窓口までお寄せください。
                  </p>
                  <address className={`my-4`}>
                    <p>
                      〒113-0033 東京都文京区本郷1-20-3 中山ビル5階
                    </p>
                    <p>
                      NAMU TECH JAPAN株式会社
                    </p>
                    <p>
                      個人情報に関するお問合せ窓口担当
                    </p>
                    <p>
                      電話番号：03-6240-0471 メールアドレス：pms@namutech.co.jp
                    </p>
                    <p>
                      窓口受付時間：10:00～17:00（土日祝日を除く月曜日～金曜日）
                    </p>
                  </address>
                </div>
                <div className={`text-base privacy-policy`}>
                  <h3 className={`text-base md:text-lg text-[#243242] text-center font-medium`}>
                    当社が取扱う個人情報について
                  </h3>
                  <p className={`mt-4`}>
                    {`　`}当社では「個人情報保護方針」に基づき個人情報の適切な保護に取り組んでいます。当社が事業の用に供するために取得し、または保有する個人情報について、以下の通りお知らせいたします。
                  </p>
                  <ListWithBrackets className={`mt-6 space-y-5`}>
                    <li>
                      <p className={`font-medium`}>
                        個人情報の取扱事業者の名称及び住所並びに法人にあたってはその代表者の氏名
                      </p>
                      <p>
                        事業者名：NAMU TECH JAPAN株式会社
                      </p>
                      <p>
                        代表取締役：李 秀秉
                      </p>
                      <p>
                        住所：東京都文京区本郷1-20-3 中山ビル5階
                      </p>
                    </li>
                    <li>
                      <p className={`font-medium`}>
                        個人情報保護管理者（若しくはその代理人）の氏名又は職名、所属及び連絡先
                      </p>
                      <p>
                        個人情報保護管理者：権 泰旭
                      </p>
                      <p>
                        電話番号：03-6240-0471
                      </p>
                    </li>
                    <li>
                      <p className={`font-medium`}>
                        個人情報の利用目的
                      </p>
                      <p>
                        当社が事業活動において取扱う個人情報の利用目的は、次の通りといたします。
                      </p>
                      <div className={`my-2`}>
                        <p>① 保有個人データ（注1）</p>
                        <ul className={`list-disc pl-7 my-1`}>
                          <li>
                            <p>
                              お客様情報
                            </p>
                            <p>
                              商談及び業務上の諸連絡、受注業務、請求業務等のため
                            </p>
                          </li>
                          <li>
                            <p>
                              株主情報
                            </p>
                            <p>
                              情報公開、配布物の送付、連絡のため
                            </p>
                          </li>
                          <li>
                            <p>
                              委託先情報
                            </p>
                            <p>
                              商談及び業務上の諸連絡、発注業務、支払業務等のため
                            </p>
                          </li>
                          <li>
                            <p>
                              従業者情報
                            </p>
                            <p>
                              従業者の人事労務管理、業務管理、健康管理、セキュリティ管理のため
                            </p>
                          </li>
                          <li>
                            <p>
                              採用応募者情報
                            </p>
                            <p>
                              採用業務のため
                            </p>
                          </li>
                          <li>
                            <p>
                              本人および代理人の情報（開示等請求時）
                            </p>
                            <p>
                              開示等の求めに回答するため
                            </p>
                          </li>
                          <li>
                            <p>
                              お問合せ者情報
                            </p>
                            <p>
                              お問合せにご対応するため
                            </p>
                          </li>
                        </ul>
                        <p>
                          （注1）ホームページのお問合せフォームや電子メール等によるものを含みます。
                        </p>
                        <p>
                          その他、個別に書面で明示したとおりの利用目的とします。
                        </p>
                      </div>
                      <div className={`my-2`}>
                        <p>② それ以外取得個人情報</p>
                        <ul className={`list-disc pl-7 my-1`}>
                          <li>
                            <p>
                              お客様情報
                            </p>
                            <p>
                              商談及び業務上の諸連絡、受注業務、請求業務等のため
                            </p>
                          </li>
                          <li>
                            <p>
                              委託先情報
                            </p>
                            <p>
                              商談及び業務上の諸連絡、発注業務、支払業務等のため
                            </p>
                          </li>
                          <li>
                            <p>
                              採用応募者情報
                            </p>
                            <p>
                              就職斡旋サイトや人材紹介会社から取得した採用応募者の採用業務のため
                            </p>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <p className={`font-medium`}>
                        個人情報の第三者提供
                      </p>
                      <p>
                        当社は以下に該当する場合、お客様等（注2）の個人情報を第三者へ提供することがあります。
                      </p>
                      <ListWithBrackets className={`my-1`}>
                        <li>
                          <p>法令に基づく場合</p>
                        </li>
                        <li>
                          <p>ご本人様の同意がある場合</p>
                        </li>
                        <li>
                          <p>人の生命、身体または財産の保護のために必要がある場合であって、ご本人様の同意を得ることが困難である場合</p>
                        </li>
                        <li>
                          <p>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、ご本人様の同意を得ることが困難である場合</p>
                        </li>
                        <li>
                          <p>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ご本人様の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合</p>
                        </li>
                        <li>
                          <p>当社が利用目的を達成するために必要な範囲内において、お客様等から提供された情報の取り扱いの全部または一部を委託する場合</p>
                        </li>
                      </ListWithBrackets>
                      <p>
                        （注2）当社のお客様、委託先、採用応募者及び従業員を指します。
                      </p>
                    </li>
                    <li>
                      <p className={`font-medium`}>
                        個人情報取扱いの委託
                      </p>
                      <p>
                        当社は事業運営上、業務をより適切かつ効果的に遂行するために業務の一部を外部に委託しています。業務委託先に対しては、お客様等の個人情報を預けることがあります。この場合、個人情報を適切に取り扱っていると認められる委託先を選定し、契約書等によって個人情報の適正管理・機密保持など、お客様等の個人情報の漏洩や不適切な利用の防止に必要な事項を取決め、適切な管理を実施させます。
                      </p>
                    </li>
                    <li>
                      <p className={`font-medium`}>
                        個人情報に関するお問合せ窓口
                      </p>
                      <p>
                        保有個人データに関わるものを含め、個人情報の取扱についての苦情・相談、問合せは、下記の【問合せ窓口】までお申し出ください。
                      </p>
                    </li>
                    <li>
                      <p className={`font-medium`}>
                        所属する認定個人情報保護団体の名称および苦情の解決の申し出先
                      </p>
                      <p>
                        なし
                      </p>
                    </li>
                    <li>
                      <p className={`font-medium`}>
                        開示等の手続について
                      </p>
                      <p>
                        当社では、保有個人データに関して、ご本人の開示等（利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去、第三者への提供の停止および第三者提供記録の開示）の請求に迅速に対応いたします。ご希望される場合には、お申し出いただいた方がご本人或いはその代理人であることを確認した上で、合理的な期間及び範囲で対応いたします。
                      </p>
                    </li>
                    <li>
                      <p className={`font-medium`}>
                        開示等の受付方法・窓口
                      </p>
                      <p>
                        保有個人データに関する開示等のお申し出は、下記の受付窓口までご連絡ください。ご連絡いただきましたら、当社所定の「保有個人データ開示等請求書」を郵送または、FAX、メール等でお送り致します。内容ご記入の上必要書類を同封し、郵送またはメール等にてお申し込み下さい。（送付料は請求者のご負担となります。）
                      </p>
                      <p>
                        ご本人（または代理人）であることを確認した上で、ご希望の開示方法により回答いたします。
                      </p>
                    </li>
                    <li>
                      <p className={`font-medium`}>
                        個人情報の安全管理のために講じた措置について
                      </p>
                      <p>
                        当社では、個人情報を厳正に取り扱うため、JIS Q
                        15001に準拠した個人情報保護方針を基に、個人情報に関する規程等を策定し、個人情報保護マネジメントシステムを運用しています。個人情報の適正な取扱いの確保のため、組織的・人的・物理的・技術的の4つの観点より安全管理措置を講じています。
                      </p>
                      <ul className={`list-disc pl-7 my-2`}>
                        <li>
                          <p>組織的対策</p>
                          <ul className={`list-[circle] pl-7`}>
                            <li>
                              従業員を監督し、個人情報漏えい等の緊急事態発生時の責任者への報告連絡体制を整備しています。
                            </li>
                            <li>
                              個人情報の取り扱い状況について定期的に社内監査にて確認しています。
                            </li>
                            <li>
                              利用目的に照らして不要となった個人情報については、速やかに且つ適正に削除・廃棄いたします。
                            </li>
                          </ul>
                        </li>
                        <li>
                          <p>人的対策</p>
                          <ul className={`list-[circle] pl-7`}>
                            <li>
                              全従業員を対象に年1回個人情報保護研修を実施しています。
                            </li>
                            <li>
                              個人情報を含む機密保持契約書類を取得しています。
                            </li>
                          </ul>
                        </li>
                        <li>
                          <p>物理的対策</p>
                          <ul className={`list-[circle] pl-7`}>
                            <li>
                              入退室管理を実施し、当社で許可した場所以外での取り扱いを禁止するとともに、権限を有しない者による個人情報の閲覧を防止する措置を実施しています。
                            </li>
                            <li>
                              個人情報を取り扱う機器、電子媒体及び書類等は事業所内の移動を含め、社外で持ち運ぶ場合、盗難・紛失に注意するとともに容易に個人情報が判明しないよう措置を講じています。
                            </li>
                          </ul>
                        </li>
                        <li>
                          <p>技術的対策</p>
                          <ul className={`list-[circle] pl-7`}>
                            <li>
                              アクセス権を持つIDは個人情報保護管理者が発行・更新・廃棄の管理を行い、情報を使用しなくなったユーザのアクセス権は直ちに抹消します。
                            </li>
                          </ul>
                        </li>
                      </ul>
                      <p>
                        具体的な安全管理措置については下記【問合せ窓口】よりお問い合わせください。
                      </p>
                    </li>
                  </ListWithBrackets>
                  <p className={`text-end mt-6`}>
                    2023年10月1日制定
                  </p>
                  <p className={`text-end`}>
                    2026年4月16日改訂
                  </p>
                  <div className={`mt-8 flex flex-col items-center gap-4 md:flex-row md:gap-6`}>
                    <a href={Constants.URL_JIPDEC} target="_blank" rel="noopener noreferrer"
                       className="shrink-0">
                      <img src="/assets/logo/p-mark_blue_jp.svg" alt="プライバシーマーク"
                           className="w-20 md:w-28"/>
                    </a>
                    <img src="/assets/privacy/privacy_contact_window.png"
                         alt="【問合せ窓口】窓口の名称：個人情報問合せ窓口 連絡先：窓口責任者 個人情報問合せ窓口担当者、住所 東京都文京区本郷1-20-3 中山ビル5階、連絡先 pms@namutech.co.jp"
                         className="w-full min-w-0 flex-1"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
);
};

export default PrivacyPolicy;

// 괄호를 넣는 ol 태그.
const ListWithBrackets = styled.ol`
counter-reset: list-counter;

> li {
  list-style: none;
  position: relative;
  padding-left: 2.8rem;

  //&:last-child::before {
  //    content: none; /* 마지막 li 요소는 숫자를 표시하지 않음 */
  //  }
  }

  > li::before {
    content: ' ( ' counter(list-counter) ' ) ';
    counter-increment: list-counter;
    position: absolute;
    left: 0;
  }
`;
